import { useState } from 'react';

/**
 * Toggle helper hook.
 * Returns a tuple consisting of the current value of the toggle + a function for toggling the current value.
 */
export const useToggle = (
  initialValue: boolean = false
): [boolean, () => void] => {
  const [value, setValue] = useState(initialValue);
  return [value, () => setValue(!value)];
};
